import React from 'react';

import PropTypes from 'prop-types';
import Strong from '@tds/core-strong';

import { Title } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';

const ProfileInfo = ({ error }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: { REGISTRATION_INFO_HEADING, REGISTRATION_INFO_FILL_DETAIL },
        ERRORS_MESSAGES: { GENERIC_ERROR_HEADING }
      }
    }
  } = localizedStrings;

  return (
    <>
      <h2>
        <div id="main-content-title">
          <Title>{REGISTRATION_INFO_HEADING}</Title>
        </div>
      </h2>
      <div id="main-content-steps">
        <Strong>{REGISTRATION_INFO_FILL_DETAIL}</Strong>
      </div>

      {error ? (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
          <div id="error-message-title">
            <span className="frg-body-font-23px">{GENERIC_ERROR_HEADING}</span>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <span className="frg-body-font-14px">
              {error}
              <br />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

ProfileInfo.propTypes = {
  error: PropTypes.bool.isRequired
};

export default ProfileInfo;
